import { StyleSheet } from '@react-pdf/renderer';

import { COLORS } from '@/shared/constants/colors';

export const styles = StyleSheet.create({
  document: {
    fontFamily: 'Garamond',
  },
  page: {
    backgroundColor: COLORS.white,
    padding: '90px 21px 220px 23px ',
  },
  watermark: {
    fontSize: '48px',
    opacity: '0.06',
    position: 'absolute',
    top: '100px',
    left: '0',
    right: '0',
    textAlign: 'center',
  },
  header: {
    fontSize: '12.75px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 34,
    top: 16,
    position: 'absolute',
    width: 794 - 50,
  },
  section: {
    padding: 33,
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    lineHeight: 1.2,
    gap: 10,
    fontSize: 11,
  },
  footer: {
    fontSize: '12.75px',
    textAlign: 'center',
    position: 'absolute',
    bottom: 50,
    left: 33,
    right: 33,
    width: 794 - 66,
    borderTop: 0,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 8,
  },
  witnesses: {
    display: 'flex',
    flexDirection: 'row',
    gap: 18,
  },
  witness: {
    gap: 10,
    flex: 1,
  },
  executors: {
    gap: 8,
  },

  witnessTitle: {
    marginBottom: 10,
  },
  placeholder: {
    color: COLORS.systemDark100,
  },
  subtitle: {
    fontWeight: 600,
    marginTop: 8,
  },
});
